import { render, staticRenderFns } from "./EmotionWheelPublicDisplayLegend.vue?vue&type=template&id=c73698e0&scoped=true"
import script from "./EmotionWheelPublicDisplayLegend.vue?vue&type=script&lang=js"
export * from "./EmotionWheelPublicDisplayLegend.vue?vue&type=script&lang=js"
import style0 from "./EmotionWheelPublicDisplayLegend.vue?vue&type=style&index=0&id=c73698e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73698e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c73698e0')) {
      api.createRecord('c73698e0', component.options)
    } else {
      api.reload('c73698e0', component.options)
    }
    module.hot.accept("./EmotionWheelPublicDisplayLegend.vue?vue&type=template&id=c73698e0&scoped=true", function () {
      api.rerender('c73698e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/EmotionWheelPublicDisplayLegend.vue"
export default component.exports